import {Box, Button, IconButton, Stack, Tooltip, Typography} from "@mui/material";
import {HugeiconsIcon} from "@hugeicons/react";
import {ArrowLeft01Icon, PencilEdit01Icon, Refresh01Icon} from "@hugeicons/core-free-icons";

const roundButtonSx = {borderRadius: "50% !important", color: "#8A8AA0", "&:hover": {bgcolor: "#F4F4FA", color: "#4A4A63"}};

export const CampaignDetailsHeaderNew = ({campaign, onBack, onRefresh, onEdit}) => {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
      <Stack direction="row" alignItems="center" gap={1}>
        <IconButton onClick={onBack} sx={roundButtonSx}><HugeiconsIcon icon={ArrowLeft01Icon}/></IconButton>
        <Box>
          <Typography sx={{fontSize: 20, fontWeight: 700, color: "#23264D", letterSpacing: "-0.01em"}}>{campaign?.name || "Campaign"}</Typography>
          {campaign?.description && <Typography sx={{fontSize: 13, color: "#6B6B80"}}>{campaign.description}</Typography>}
        </Box>
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        <Tooltip title="Refresh">
          <IconButton onClick={onRefresh} sx={roundButtonSx}><HugeiconsIcon icon={Refresh01Icon} size={19}/></IconButton>
        </Tooltip>
        <Button
          size="small"
          startIcon={<HugeiconsIcon icon={PencilEdit01Icon} size={16}/>}
          onClick={onEdit}
          sx={{
            height: 36, px: 1.75, borderRadius: "10px", textTransform: "none", fontSize: 13, fontWeight: 700,
            color: "#374151", bgcolor: "#FAFAFD", "&:hover": {bgcolor: "#ECECF3"},
          }}
        >
          Edit campaign
        </Button>
      </Stack>
    </Stack>
  )
}
